var m = require('mithril');
var headingElement = require('../../components/heading');
var buttonElement = require('../../components/button');
var choices = require('../../libs/choices');
var Point = require('../models/point');
var resource = require('../../network/models/resource');
var alarmState = require('../../alarms/alarmState');
var loaders = require('../../layout/components/loaders');
var pagination = require('./pagination');
var auth = require('../../auth/models/session');

function hasAlarmEvaluationError(pointRecord) {
  var alarmError = pointRecord && pointRecord.alarmError;
  return alarmError === true || alarmError === 1 || alarmError === '1' || alarmError === 'true';
}

function oninit (vnode) {
  var ctrl = this;
  ctrl.parentCtrl = vnode.attrs.parentCtrl;
  vnode.state.redraw = false;
  ctrl.userListOpened = false;

  loaders.requestWithLoader({
    url: '/api/v1/group/',
    method: 'GET',
  })
  .then(function (groups)  {
    ctrl.groups = groups.map(function (group, idx) {
      return {key: group.name, value: group['@rid']}
    })
  });  

  loaders.requestWithLoader({
    url: '/api/v1/alarmprofile/',
    method: 'GET',
    background: true
  }).then(function(results){
    ctrl.alarmProfiles=results
  })

  ctrl.toggleHour = function toggleHour (hour) {
    var found = Point.form.excludedHours().findIndex(function (el) {
      return el == hour
    });

    if (found > -1) {
      Point.form.excludedHours().splice(found, 1);
    } else {
      Point.form.excludedHours().push(hour);
    }
  }

  ctrl.toggleDayOfWeek = function toggleHour (day) {
    var found = Point.form.excludedDaysOfWeek().findIndex(function (el) {
      return el == day
    });

    if (found > -1) {
      Point.form.excludedDaysOfWeek().splice(found, 1);
    } else {
      Point.form.excludedDaysOfWeek().push(day);
    }
  }

  ctrl.getUsersfromGruops = ()=>{
    loaders.requestWithLoader({
      url: '/api/v1/groups/users',
      method: 'GET',
      params: {
        groups: Point.form.receivers(),
      },
    })
    .then(function (users)  {
      ctrl.usersReceivers = users.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t['@rid'] === value['@rid']
        ))
      )
      m.redraw();
    });  
  }
  ctrl.getUsersfromGruops();

  ctrl.openUserList = function () {
    ctrl.userListOpened = !ctrl.userListOpened;
    m.redraw();
  }
}

function view () {
  var ctrl= this
  if (!ctrl.groups || !ctrl.alarmProfiles || !ctrl.usersReceivers){
    return m('div')
  }

  function alarmRangeParams () {
    return [
      m(headingElement, {label: "High Limit"}),
      m("form", [
        m("div.mb2",[
          m("input", {
            type: 'number',
            value: Point.valueSourceToUser(ctrl.parentCtrl.point(), Point.form.alarmHiLimit(), true),
            onchange: function (evt) {
                Point.form.alarmHiLimit(Point.valueUserToSource(ctrl.parentCtrl.point(), evt.target.value));
              }
            }, [
          ])
        ])
      ]),
      m(headingElement, {label: "Low Limit"}),
      m("form", [
        m("div.mb2",[
          m("input", {
          type: 'number',
          value: Point.valueSourceToUser(ctrl.parentCtrl.point(), Point.form.alarmLoLimit(), true), 
          onchange: function (evt) {
              Point.form.alarmLoLimit(Point.valueUserToSource(ctrl.parentCtrl.point(), evt.target.value));
            }
          })
        ])
      ])
    ]
  }

  function alarmDelayParams () {
    return [
      m(headingElement, {label: "Trip Delay"}),
      m("form", [
        m("div.mb2",[
          m("input", {
            type: 'number',
            value: Point.form.tripTimeout(), 
            oninput: function (ev) { Point.form.tripTimeout(ev.target.value)}
          })
        ])
      ]),
      m(headingElement, {label: "Reset Delay"}),
      m("form", [
        m("div.mb2",[
          m("input", {
            type: 'number',
            value: Point.form.resetTimeout(), 
            oninput: function (ev) { Point.form.resetTimeout(ev.target.value)}
          })
        ])
      ])
    ]
  }

  function notifyResetParam () {
    return [
      m(headingElement, {label: "Notify Resets"}),
      m("form", [
        m("div.mb2",[
          m("select.form-control", {value: Point.form.notifyReset(), onchange: function (ev) { Point.form.notifyReset(ev.target.value)}}, [
            m("option", {value:0}, 'False'),
            m("option", {value:1}, 'True')
          ])
        ])
      ])
    ]
  }

  function alarmReceiversParam () {
    if (!auth.isSuperuser()) {
      return [];
    }

    return [
      m(headingElement, {label: "Alarm Receivers"}),
      m('div.mb2', [
        m(choices, {
          data: ctrl.groups,
          value: Point.form.receivers,
          onchange: ()=>{
            ctrl.getUsersfromGruops();
          }
        })
      ])
    ];
  }

  function alarmDeltaParams () {
    return m('div');
  }

  function alarmTypeParams () {
    switch (Point.form.alarmType()) {
      case 'range':
        return alarmRangeParams();

      case 'boolean':
        return alarmBooleanParams();

      case 'delta':
        return alarmDeltaParams();
    }
  }

  function alarmBooleanParams () {
    return [
      m(headingElement, {label: "Alarm Behavior"}),    
      m("form", [
        m("div.mb2",[
          m("select.form-control", {value: Point.form.alarmReverseBoolean(), onchange: function (ev) { Point.form.alarmReverseBoolean(ev.target.value)}}, [
            m("option", {value: 0}, 'Alarm on True'),
            m("option", {value: 1}, 'Alarm on False'),
          ])
        ])
      ])
    ]
  }

  function alarmConfigurations () {
    return [
      m(headingElement, {label: "Type"}),    
      m("form", [
        m("div.mb2",[
          m("select.form-control", {value: Point.form.alarmType(), onchange: function (ev) { Point.form.alarmType(ev.target.value)}}, [
            m("option", {value:'range'}, 'Range'),
            m("option", {value:'boolean'}, 'Boolean'),
            m("option", {value:'delta'}, 'Delta')
          ])
        ])
      ]),

      alarmTypeParams(),
      alarmDelayParams(),
      notifyResetParam(),
      m(headingElement, {label: "Excluded Days"}),
      m('div.flex.justify-between', [
        m('div.flex', [
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 0 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(0)},
              },
              'Sun'
            )
          ]),
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 1 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(1)},
              },
              'Mon'
            )
          ]),
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 2 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(2)},
              },
              'Tue'
            )
          ]),
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 3 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(3)},
              },
              'Wed'
            )
          ]),
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 4 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(4)},
              },
              'Thu'
            )
          ]),
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 5 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(5)},
              },
              'Fri'
            )
          ]),
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedDaysOfWeek().find(function (el) { return el == 6 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleDayOfWeek(6)},
              },
              'Sat'
            )
          ])
        ])
      ]),
      m(headingElement, {label: "Excluded Hours"}),
      m('div.flex.justify-between', [
        m('div.flex', [
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedHours().find(function (el) { return el == 0}) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleHour(0)},
              },
              12
            )
          ]),        
          Array(11).fill(1).map(function (k, idx) {
          return m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedHours().find(function (el) { return el == idx + 1 }) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleHour(idx + 1)},
              },
              idx + 1
            )
          ])
        })]),
        m('div.v-mid.tc.ba.bw1.pa3.ma1.mr0', 'AM'),
      ]),
      m('div.flex.justify-between.mb2', [
        m('div.flex', [
          m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedHours().find(function (el) { return el == 12}) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleHour(12)},
              },
              12
            )
          ]),
          Array(11).fill(1).map(function (k, idx) {
          return m('div.dt.pv1.mr1', [
            m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (Point.form.excludedHours().find(function (el) { return el == idx + 13}) > -1 ? 'bg-blue' : ''), 
              {
                onclick: function () {ctrl.toggleHour(idx + 13)},
              },
              idx + 1
            )
          ])
        })]),
        m('div.v-mid.tc.ba.bw1.pa3.ma1.mr0', 'PM'),
      ])
    ]
  }

  return m('div', [
    (function () {
      var hasError = ctrl.parentCtrl && ctrl.parentCtrl.point && hasAlarmEvaluationError(ctrl.parentCtrl.point());
      if (!hasError) return null;
      return m('div.mb2.pa2.ba.bw1.b--yellow.yellow', [
        m('span.mr1', '⚠️'),
        m('span', 'There is an error evaluating this alarm. Notifications may be triggered due to the error until it resets.')
      ]);
    })(),
    (function () {
      var enabled = Number(Point.form.alarmEnabled()) === 1;
      var interval = Number(typeof resource.form.interval === 'function' ? resource.form.interval() : resource.form.interval);
      var intervalMissing = !Number.isFinite(interval) || interval <= 0;
      if (!enabled || !intervalMissing) return null;
      return m('div.mb2.pa2.ba.bw1.b--yellow.yellow', [
        m('span.mr1', '⚠️'),
        m('span', 'Set a sampling interval to ensure the alarm will be polled for changes.')
      ]);
    })(),
    (function () {
      return m(headingElement, {label: ['Enabled']});
    })(),
    m("form", [
      m("div.mb2",[
        m("select.form-control", {value: Point.form.alarmEnabled(), onchange: function (ev) { Point.form.alarmEnabled(ev.target.value)}}, [
          m("option", {value:0}, 'False'),
          m("option", {value:1}, 'True')
        ])
      ])
    ]),
    m(headingElement, {label: "Alarm Name"}),
    m("form", [
      m("div.mb2",[
        m("input", {
          type: 'text',
          value: Point.form.alarmName(), 
          oninput:  function (ev) { Point.form.alarmName(ev.target.value)}
          })
      ])
    ]),
    m(headingElement, {label: "Alarm Description"}),
    m("form", [
      m("div.mb2",[
        m("input", {
          type: 'text',
          value: Point.form.alarmDescription(), 
          oninput: function (ev) { Point.form.alarmDescription(ev.target.value)}
        })
      ])
    ]),
    alarmReceiversParam(),
    m(headingElement, {label: "Alarm Profile"}),    
    m("form", [
      m("div.mb2",[
        m("select.form-control", {value: Point.form.alarmProfile() == null ? 'None': Point.form.alarmProfile(), onchange: function (ev) { 
          if(ev.target.value == 'None') Point.form.alarmProfile(null)
          else Point.form.alarmProfile(ev.target.value)
        }}, [
          m('option', 'None'),
          ctrl.alarmProfiles.map(function (alarmProfile) {
            return m('option', {value: alarmProfile['@rid']}, alarmProfile.name)
          })
        ])
      ])
    ]),
    (function () {
      if (Point.form.alarmProfile() == null || Point.form.alarmProfile() == 'null') {
        return alarmConfigurations();
      } else {
        return [];
      }
    })(),

    m('div', { class: 'ba pa3 bw1 mv2 b--blue', id: `collapsable-list-users`}, [
      m('div', { onclick: ()=>{ctrl.openUserList()} }, [
        m('label', { class: 'event-label' }, `Receiver List`),
        m('i', { class: 'icon fr ' + (ctrl.userListOpened ? 'ion-chevron-up' : 'ion-chevron-down') }),
      ]),
      m('div', { id: `collapsable-body-users`, class: (ctrl.userListOpened ? '' : 'dn') }, [
        m('div.panel.panel-body', [
          m('table', { class: 'table w-100 mb3' }, [
            m('tbody',[
              ctrl.usersReceivers.map(userRecord => {
                return m('tr', [
                  m('td.fw2.tc', userRecord.firstName + ' ' + userRecord.lastName),
                  m('td.fw2.tc', userRecord.email),
                ])
              })
            ])
          ]),
          (()=>{
            if(ctrl.usersReceivers.length > 0){
              return m(pagination, {data: ctrl.usersReceivers})
            }
          })(),
        ])
      ]),
    ]),
    Point.errorView(),
    m(buttonElement, {
      label: 'Submit',
      class: 'w4 fr tc',
      func: Point.save.bind(Point)
    })
  ])
}

module.exports = {oninit: oninit, view: view}
